export default function Truncate({ text, max = 60, className = "" }) {
  const t = (text ?? "").toString();
  if (!t) return <span className="text-gray-400">—</span>;
  if (t.length <= max)
    return <span className={`break-words ${className}`}>{t}</span>;
  return <span className={`break-words ${className}`}>{t.slice(0, max)}…</span>;
}
